import commonUtil from './../../utils/commonUtil';

export const FOOTER_CONTENT_LOAD = 'FOOTER_CONTENT_LOAD';
export const FOOTER_CONTENT_LOAD_SUCCESS = 'FOOTER_CONTENT_LOAD_SUCCESS';
export const FOOTER_CONTENT_LOAD_FAIL = 'FOOTER_CONTENT_LOAD_FAIL';


export function isContentLoadedForFooter(globalState) {
  return globalState.footer && globalState.footer.loaded;
}

export function loadContentForFooter(isLogedin) {
  const _footerInput = {};
  let _footerTargeter = '';
  _footerInput.brand = commonUtil.getBrand();
  _footerInput.channel = commonUtil.getChannel();
  if (isLogedin) {
    _footerTargeter = 'GRFooterTargeterForLoggedInUser';
  } else {
    _footerTargeter = 'GRFooterTargeterForAnonymousUser';
  }
  _footerInput.requiredTargeters = [_footerTargeter];
  return {
    types: [FOOTER_CONTENT_LOAD, FOOTER_CONTENT_LOAD_SUCCESS, FOOTER_CONTENT_LOAD_FAIL],
    promise: client => client.post('/api/footer', {
      data: (_footerInput),
    }), // params not used, just shown as demonstration
  };
}

// export function loadContentForFooter() {
//   return {
//     types: [FOOTER_CONTENT_LOAD, FOOTER_CONTENT_LOAD_SUCCESS, FOOTER_CONTENT_LOAD_FAIL],
//     promise: client => client.get('/api/footerContent'), // params not used, just shown as demonstration
//   };
// }
